import { DownOutlined } from "@ant-design/icons";
import { Col, Row } from "antd";
import React, { useState } from "react";
import Emoji from "react-emoji-render";
import { useLocation } from "react-router-dom";

import discord_channels from "../../../types/discord_channels";
import { useDiscordChannelsContext } from "../ChannelContext/ChannelContext";
// eslint-disable-next-line import/extensions
import { useEndTime, useStartTime } from "../DateContext/DateContext";
import DiscordMostActiveMembersCard from "../DiscordMostActiveMembersCard/DiscordMostActiveMembersCard";
import QuickEngagementCard from "../QuickEngagementCard/QuickEngagementCard";

function DiscordChannelDetail() {
  const guildId = localStorage.getItem("guild-id");
  const { startTime, setStartTime } = useStartTime();
  const { endTime, setEndTime } = useEndTime();
  const {
    loading: loadingDiscord,
    allChannels,
    setChannels,
    selectedChannel,
    setSelectedChannel,
  } = useDiscordChannelsContext();

  return (
    <div>
      {selectedChannel && (
        <Row gutter={[32, 32]} style={{ marginBottom: 50, marginTop: 40 }}>
          <Col span={12}>
            <DiscordMostActiveMembersCard
              guildId={guildId}
              channelId={selectedChannel.discord_id}
            />
          </Col>
          <Col span={12}>
            <QuickEngagementCard
              platform="discord"
              channelId={selectedChannel.discord_id}
            />
          </Col>
        </Row>
      )}
    </div>
  );
}

export default DiscordChannelDetail;
